export default function PHP_substr_count() {
  return (
    <div>
      <h1>PHP_substr_count</h1>
    </div>
  );
}
